import { initCatalog } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/catalog/index.js?vue3';

initCatalog();
